import { AccountSectionWrapper, ANCHOR_TAGS } from './AccountSectionWrapper'
import { RENDER_LIMIT_INDEX, WishlistItemBlock } from './AccountWishlists'
import { useAccountLayoutContext } from './AccountProfileContext'
import { accountTranslations } from '../helpers/translations'

export const AccountKidsProfileWishlist = ({ profile, connectionId, handleRefetch }) => {
  const { handPushChildState } = useAccountLayoutContext()

  const { wishlist } = profile

  const handleViewWishlist = () => {
    if (wishlist?.id) {
      handPushChildState('wishlist', wishlist.id)
    }
  }

  const items = wishlist?.items || []
  const remainingItems = (wishlist?.items || []).length - RENDER_LIMIT_INDEX

  return (
    <AccountSectionWrapper
      anchorTag={ANCHOR_TAGS.WISHLIST.tag}
      title={`${profile.first_name}${profile.first_name.endsWith('s') ? "'" : "'s"} wishlist`}
      cta={{
        title: accountTranslations.kids_profiles.wishlist.cta,
        textButton: true,
        callback: handleViewWishlist
      }}
      showDivider={false}
      mobileCtaBottom={true}
    >
      <div className={'grid grid-cols-4 gap-1'}>
        {items.length > 0 ? (
          items
            .sort((a, b) => {
              if (a?.meta?.img && !b?.meta?.img) {
                return -1 // a comes first
              }
              // Check if b has img defined and a does not
              if (!a?.meta?.img && b?.meta?.img) {
                return 1 // b comes first
              }
              return 0
            })
            .map((item, index) => {
              return (
                <WishlistItemBlock
                  index={index}
                  totalItems={items.length}
                  item={item}
                  remainingItems={remainingItems}
                />
              )
            })
        ) : (
          <div className={'w-full aspect-square bg-neutrals-base'}>
            <div className="flex flex-col items-center justify-center h-full">
              <p className="text-center">{accountTranslations.kids_profiles.wishlist.no_items}</p>
            </div>
          </div>
        )}
      </div>
    </AccountSectionWrapper>
  )
}
